export enum SessionStateEnums {
    ACTIVE_REQUEST = 'active-request',
    INITIAL_MOUNT = 'initial-mount'
}
